// API service for properties

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
            ...options,
        });

        if (!response.ok) {
            throw new Error(`API Error: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

// Get all properties with optional filters
export const getProperties = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    
    if (filters.location) queryParams.append('location', filters.location);
    if (filters.type) queryParams.append('type', filters.type);
    if (filters.price) queryParams.append('price', filters.price);

    const queryString = queryParams.toString();
    const endpoint = `/properties${queryString ? `?${queryString}` : ''}`;
    
    return await apiCall(endpoint);
};

// Get single property by ID
export const getPropertyById = async (id) => {
    return await apiCall(`/properties/${id}`);
};

// Create new property
export const createProperty = async (propertyData) => {
    return await apiCall('/properties', {
        method: 'POST',
        body: JSON.stringify(propertyData),
    });
};

// Update property
export const updateProperty = async (id, propertyData) => {
    return await apiCall(`/properties/${id}`, {
        method: 'PUT',
        body: JSON.stringify(propertyData),
    });
};

// Delete property
export const deleteProperty = async (id) => {
    return await apiCall(`/properties/${id}`, {
        method: 'DELETE',
    });
};

// Upload image
export const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch(`${API_BASE_URL}/upload`, {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Upload Error: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Upload Error:', error);
        throw error;
    }
};

// Health check
export const checkHealth = async () => {
    return await apiCall('/health');
};
